module.exports = __webpack_public_path__ + "static/media/MainChart.84bb27e2.jpg";